import { matchPath, useLocation } from 'react-router-dom';
import { defaultRouteConfig, routesConfig } from 'src/routesConfig';

export const useRouteInfoForCurrentPath = () => {
  const location = useLocation();

  return (
    routesConfig.find(
      (routeInfo) =>
        matchPath(
          {
            path: routeInfo.path,
            caseSensitive: false,
            end: true,
          },
          location.pathname
        ) != null
    ) || defaultRouteConfig
  );
};
